// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container styling */
.tab8-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Header styling */
.tab8-container h3 {
    color: #333;
    margin-bottom: 15px;
}

/* Checkbox styling */
.tab8-checkbox-group {
    margin-bottom: 10px;
}

.tab8-checkbox-group label {
    margin-left: 8px;
    font-size: 16px;
    color: #333;
}

.tab8-checkbox-group input[type="checkbox"] {
    transform: scale(1.2);
    margin-right: 8px;
}

/* Folder merge checkbox with chart color */
.tab8-folder-merge-label {
    display: flex;
    align-items: center;
}

.tab8-folder-merge-label span {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: 8px;
}

/* Styled Submit Button */
.submit-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.submit-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.submit-button:not(:disabled):hover {
    background-color: #0056b3;
    transform: translateY(-2px);
}

.submit-button:not(:disabled):active {
    background-color: #004494;
    transform: translateY(0);
}

/* Additional spacing for the button */
.submit-button-container {
    margin-top: 20px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/survey/tab8/Tab8FolderSelection.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,sCAAsC;AACtC;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* General container styling */\n.tab8-container {\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Header styling */\n.tab8-container h3 {\n    color: #333;\n    margin-bottom: 15px;\n}\n\n/* Checkbox styling */\n.tab8-checkbox-group {\n    margin-bottom: 10px;\n}\n\n.tab8-checkbox-group label {\n    margin-left: 8px;\n    font-size: 16px;\n    color: #333;\n}\n\n.tab8-checkbox-group input[type=\"checkbox\"] {\n    transform: scale(1.2);\n    margin-right: 8px;\n}\n\n/* Folder merge checkbox with chart color */\n.tab8-folder-merge-label {\n    display: flex;\n    align-items: center;\n}\n\n.tab8-folder-merge-label span {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-left: 8px;\n}\n\n/* Styled Submit Button */\n.submit-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.submit-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.submit-button:not(:disabled):hover {\n    background-color: #0056b3;\n    transform: translateY(-2px);\n}\n\n.submit-button:not(:disabled):active {\n    background-color: #004494;\n    transform: translateY(0);\n}\n\n/* Additional spacing for the button */\n.submit-button-container {\n    margin-top: 20px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
